module.exports = __webpack_public_path__ + "assets/a848cfde774c0862abd9641e3d8e362a.mp3";